export const PROXY_ENDPOINTS = {
    EXPLORE: "explore-api",
};
